import { ApiBaseFront } from "../../front/api-base-front";

export type PrintMetaShopOrderPostRequest = {
  kijshopCd: string,
  shopOrderId: string,
  lastName: string,
  status: string,
  createDate: string,
  lastUpdateDate: string,
  orderDate?: string,
  orderCompleteDate: string | null,
  orderUser: string | null,
  note: string,
};

export class ApiPrintMetaShopOrderPost extends ApiBaseFront {
  constructor(param: PrintMetaShopOrderPostRequest) {
    const {
      kijshopCd,
      ..._param
    } = param;
  
    super(
      'POST',
      `/api/v1/print/shop/${kijshopCd}/meta/shopOrder`,
      'JSON',
      _param,
    );
  }
}

export type MetaPrintShopOrderGetResponse = {
  kijshopCd: string,
  shopOrderId: string,
  lastName: string,
  status: string,
  createDate: string,
  lastUpdateDate: string,
  orderDate?: string,
  orderCompleteDate: string | null,
  orderUser: string | null,
  note: string,
  lockUser: string,
  centerShippinDate: string,
  // コピーして新規で作成された注文のコピー元注文番号(通常注文は未設定)
  copySrcShopOrderId?: string | null,
};

export class ApiPrintMetaShopOrderGet extends ApiBaseFront<MetaPrintShopOrderGetResponse> {
  constructor(param: { kijshopCd: string, shopOrderId: string }) {
    const { kijshopCd, shopOrderId } = param;
    super(
      'GET',
      `/api/v1/print/shop/${kijshopCd}/meta/shopOrder/${shopOrderId}`,
      'JSON',
      {
        kijshopCd,
        shopOrderId,
      },
    );
  }
}

export class ApiPrintMetaShopOrderDelete extends ApiBaseFront {
  constructor(param: { kijshopCd: string, shopOrderId: string }) {
    const { kijshopCd, shopOrderId } = param;
    super(
      'DELETE',
      `/api/v1/meta/shopOrder/${kijshopCd}/${shopOrderId}`,
      'JSON',
      {},
    );
  }
}
